import { isDefined } from "@utils/helpers";
import { AnySearchConfiguration } from "@utils/search/@types/searchConfiguration";
import { MayBeConfigurationToRouteEntriesMapper } from "@utils/search/routing/configurationToUrl/configurationToRouteEntries";
import {
    DEFAULT_ROUTE,
    PREFIX_SEPARATOR,
} from "@utils/search/routing/routing.configuration";

const mapDefault: MayBeConfigurationToRouteEntriesMapper = (
    { component, ...rest },
    prefix,
) =>
    Object.entries(rest)
        .map(([key, value]) => {
            const defaultValue =
                DEFAULT_ROUTE[key as keyof AnySearchConfiguration];
            if (defaultValue === undefined || defaultValue === value) {
                return;
            }

            return [
                `${prefix}${PREFIX_SEPARATOR}${key}`,
                value.toString(),
            ] as const;
        })
        .filter(isDefined);

export { mapDefault };
